import { render } from "./SaleStatusBadge.vue?vue&type=template&id=339a93de"
import script from "./SaleStatusBadge.vue?vue&type=script&lang=js"
export * from "./SaleStatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__